<template>
  <div class="coupon-container">
    <div class="post" v-for="(item, index) in list" :key="index">
      <div class="yuan"></div>
      <div class="top">
        <div class="yellow">{{item.TCU_TYPE}}</div>
        <div class="money">¥{{item.TCP_QSMONEY}}</div>
        <!-- <div class="man">满100元可用</div> -->
        <div class="time">{{item.TCP_STTIME}}-</div>
        <div class="time" style="margin-top:5px">{{item.TCP_ENDTIME}}</div>
      </div>
      <div class="btm">
        <div class="line">
          <div class="title">
            类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型：
          </div>
          <div class="sub">{{item.TCU_TCP_TYPE}}</div>
        </div>
        <div class="line">
          <div class="title">产品类型：</div>
          <div class="sub">{{item.TCP_CPTYPE}}</div>
        </div>
        <div class="line">
          <div class="title">互斥类型：</div>
          <div class="sub">{{item.TCP_HCTYPE}}</div>
        </div>
        <div class="line">
          <div class="title">阶梯类型：</div>
          <div class="sub">{{item.TCP_JTTYPE}}</div>
        </div>
        <div class="line">
          <div class="title">使用范围：</div>
          <div class="sub">{{item.TCP_CP}}</div>
        </div>
        <div class="line">
          <div class="title">优惠券编号：</div>
          <div class="sub">{{item.TCU_SEQ}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, setup, ref, getCurrentInstance } from "vue";
export default {
  setup() {
    let { proxy } = getCurrentInstance();
    let list=ref([])
    onMounted(() => {
      proxy.$axios.postReq("/meide/REST/ajaxmdmineCoupon", {
          postType:'querylist'
      }).then((res) => {
        if (res.success == "true") {
            list.value=res.items
        //   if (res.items) {
        //     res.items.map((item) => {
        //       item.sel = false;
           
        //     });
        //   }
        //   pageData.collections = res.items;
        //   totalNum.value = parseInt(res.rowcount);
        } else {
          proxy.$alert(res.ErrorText, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {},
          });
        }
      });
    });
    return{
        list
    }

  },
};
</script>

<style lang="scss" scoped>
.coupon-container {
  display: flex;
  flex-wrap: wrap;
  padding-left: 80px;
  background: #fff;
  padding-top: 50px;
}
.yuan {
  position: absolute;
  left: 50%;
  width: 25px;
  border-radius: 50%;
  z-index: 10;

  height: 25px;
  background: #fff;
  transform: translate(-50%, -50%);
}
.post {
  margin-bottom: 50px;
  margin-right: 30px;
  position: relative;
  width: 226px;
  box-sizing: border-box;
  border: 1px solid #e7e7e7;
}
.top {
  overflow: hidden;
  width: 100%;
  height: 176px;
  background: inherit;
  background-color: rgba(0, 144, 111, 1);
  color: #ffffff;
  //   line-height:28px;
  position: relative;
  .yellow {
    text-align: center;
    position: absolute;
    right: -25px;
    top: 10px;
    width: 111px;
    height: 25px;
    line-height: 25px;
    transform: rotate(45deg);
    background: #cc9e48;
  }
}
.money {
  margin-top: 40px;
  text-align: center;
  font-size: 36px;
}
.man {
  text-align: center;
  font-size: 12px;
}
.time {
  text-align: center;
  font-size: 12px;
  margin-top: 20px;
}
.btm {
  background: #f6f6f6;
  height: 190px;
  width: 100%;
  padding: 12px;
  .line {
   
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    .title {
      color: #7f7f7f;
       font-size: 13px;
    }
    .sub {
      color: #aaaaaa;
       font-size: 12px;
    }
  }
}
</style>